'use client';
import {createContext, useContext, useEffect, useState} from 'react';
import {addItemsToLocalStorage, deleteFromLocalStorage, getItemsFromLocalStorage} from '@/libs/local-storage.util';
import {ACCOUNT_USER_NAME} from '@/libs/constants/common.constants';

const UserContext = createContext(null);

export default function UserContextProvider({ user, children }) {
  const [storedUser, setStoredUser] = useState(user || null);
  
  useEffect(() => {
    if (!user) {
      const userFromLocalStorage = getItemsFromLocalStorage(ACCOUNT_USER_NAME);
      if (userFromLocalStorage) {
        setStoredUser(userFromLocalStorage);
      }
    } else {
      addItemsToLocalStorage(ACCOUNT_USER_NAME, user);
    }
  }, [user]);
  
  const saveUser = (user) => {
    addItemsToLocalStorage(ACCOUNT_USER_NAME, user);
    setStoredUser(user);
  }
  
  const deleteUser = () => {
    deleteFromLocalStorage(ACCOUNT_USER_NAME);
    setStoredUser(null);
  }
  
  // const getUser = () => {
  //   return storedUser || getItemsFromLocalStorage(ACCOUNT_USER_NAME) || null;
  // };
  
  return (
    <UserContext.Provider
        value={{
          user: storedUser,
          deleteUser,
          saveUser
        }}
    >{children}</UserContext.Provider>
  );
}

export const useUserContext = () => {
  return useContext(UserContext);
};
